export const demo = {
    tutorial: {
      steps: {
        "splitview-welcome": {
          title: "Welcome to Split View",
          description: "This is the Split View where you can see the map and pin list side by side. Let's start by creating your first pin!"
        },
        "splitview-drag-pin": {
          title: "Drag a Pin Icon",
          description: "Find the pin icon in the footer or use the 'Add New Pin' button. Drag the pin icon onto the map to create a new pin at that location."
        },
        "splitview-map-drop": {
          title: "Drop a Pin on the Map",
          description: "Drag the pin icon and drop it anywhere on the map. The pin editor will open automatically where you can configure the pin details."
        },
        "pineditor-welcome": {
          title: "Pin Editor",
          description: "This is where you configure your pin. Fill in the required fields to create a pin that listeners can discover."
        },
        "pineditor-name": {
          title: "Pin Name",
          description: "Give your pin a descriptive name. This will help listeners identify the pin when they discover it."
        },
        "pineditor-location": {
          title: "Location Coordinates",
          description: "The location is automatically set from where you dropped the pin. You can adjust the latitude and longitude if needed, or change the radius to control how close listeners need to be to collect this pin. Dragging the pin icon to the map will automatically update the location coordinates."
        },
        "pineditor-description": {
          title: "Pin Description",
          description: "Add an optional description to provide more context about this pin. This helps listeners understand what they'll discover here. Note: This field only appears when QR Code is enabled."
        },
        "pineditor-qr-toggle": {
          title: "Use QR Codes",
          description: "Pins are collected using geo-location, but alternatively you can enable QR codes to allow listeners to scan a QR code to collect this pin. When enabled, you can choose between single recording per QR or multiple recordings per QR. Run the QR tutorial to learn more."
        },
        "pineditor-twinned-toggle": {
          title: "Twinned Pin",
          description: "A twinned pin exists at multiple locations. When enabled, you can set coordinates for multiple locations where this pin can be collected. Run the twinned pin tutorial to learn more."
        },
        "pineditor-location-tags": {
          title: "Location Tags",
          description: "Add tags to help categorize and organize this pin. Tags like 'forest', 'river', 'city' make it easier to search and filter pins by location type."
        },
        "pineditor-save": {
          title: "Save Your Pin",
          description: "Once you've filled in the details, click Save to create the pin. You can always edit it later from the pin list."
        },
        "pinlistview-navigate-map": {
          title: "Go to Map View",
          description: "To create your first pin, its simpler tp navigate to the Map View unless you know the co-ordinates of the pin. Click the Map View button in the top navigation bar to get started."
        },
        "pinlistview-add-recording": {
          title: "Add a Recording",
          description: "This is the pin you just created! Click 'Add Recording' to add audio content to this pin. Recordings are what listeners will discover and collect when they reach this location."
        },
        "mapview-drag-pin": {
          title: "Create Your First Pin",
          description: "Drag the pin icon from the icon bar at the bottom onto the map. Try it to finish this step!"
        },
        "recordingeditor-welcome": {
          title: "Recording Editor",
          description: "This form lets you add audio recordings to your pin. Fill in the required fields to create a recording that listeners can discover."
        },
        "recordingeditor-author-information": {
          title: "Author Information",
          description: "Fill in the author details. The author image, bio, and website will appear in the app library, helping listeners identify and connect with the creator. The Author name is automatically set as a tag add others to the author tags field."
        },
        "recordingeditor-audio": {
          title: "Audio Recording",
          description: "Upload an MP3 file or record audio directly using your device's microphone. The audio you upload or record here is what listeners will hear when they collect this recording."
        },
        "recordingeditor-transcription": {
          title: "Transcription",
          description: "Add a transcription of your audio content. This is optional but helps deaf and hard-of-hearing listeners access your content. You can paste a text transcription here."
        },
        "recordingeditor-content-rating": {
          title: "Content Rating",
          description: "Select an appropriate content rating for this recording. This helps ensure listeners receive content suitable for their preferences."
        },
        "tagsview-welcome": {
          title: "Project Tags",
          description: "Tags are used to filter pins in the app. You can set subject tags and a content tag for the entire project here."
        },
        "tagsview-subject-tags": {
          title: "Subject Tags",
          description: "Add subject tags that apply to all pins in this project. These tags help listeners search and filter content by topic or theme."
        },
        "tagsview-content-tag": {
          title: "Content Tag",
          description: "Set a content tag that indicates the target audience or content rating for this project. This helps classify the project's content appropriateness."
        },
        "formconfigurator-welcome": {
          title: "Form Builder",
          description: "The Form Builder lets you configure a public submission form for your project. External contributors can use this form to submit recordings that will appear in your pin list view."
        },
        "formconfigurator-elements": {
          title: "Form Elements",
          description: "Select which fields you want contributors to fill in that you might not already have. Location Information asks for where the pin should be set, Author Information asks for the author details, Recording Information asks for the audio recording details, and Upload Fields allows audio file uploads."
        },
        "formconfigurator-password": {
          title: "Password Protection",
          description: "Optionally add a password to protect your form. Contributors will need to enter this password before they can access and submit the form. Leave it empty if you want the form to be publicly accessible."
        },
        "formconfigurator-buttons": {
          title: "Save and View",
          description: "Click 'Save Configuration' to save your form settings. Then use 'View Form' to see how the form will appear to contributors and get the shareable link."
        },
        "after-first-recording": {
          title: "Next Steps",
          description: "Great! You've added your first recording. You can now either add more pins with their own recordings, or add more recordings to the first pin for return collection. The settings icon above lets you set the cool down period between collections."
        },
        "twinning-welcome": {
          title: "Twinning Pins Tutorial",
          description: "Welcome to the Twinning Pins tutorial! Twinned pins exist at multiple locations, allowing listeners to collect the same pin from different places. Let's learn how to create one."
        },
        "twinning-toggle": {
          title: "Enable Twinning",
          description: "The twinned pin toggle is already enabled for this tutorial. When enabled, you can set coordinates for multiple locations where this pin can be collected."
        },
        "twinning-locations": {
          title: "Set Multiple Locations",
          description: "Here you can configure the coordinates for each location where this pin can be collected. Change them here or update the position of the pins on the map. Each location can have its own collection radius setting."
        },
        "qr-welcome": {
          title: "QR Code Pins Tutorial",
          description: "Welcome to the QR Code Pins tutorial! QR code pins allow listeners to scan a QR code to collect the pin instead of needing to be at a specific location. Let's learn how to create one."
        },
        "qr-toggle": {
          title: "Enable QR Codes",
          description: "The QR code toggle is already enabled for this tutorial. When enabled, listeners can scan a QR code to collect this pin."
        },
        "qr-settings": {
          title: "QR Delivery Type",
          description: "Choose how recordings are delivered via QR code. 'Single' means one recording per QR scan, while 'Multi' allows multiple recordings to be collected in order from the same QR code."
        },
        "submissions-responses-welcome": {
          title: "Submissions & Responses Tutorial",
          description: "Welcome to the Submissions & Responses tutorial! Learn how to manage user submissions and responses to recordings. Users can submit their own recordings or respond to existing ones with text or audio when a project has been set up to accept submissions and responses."
        },
        "submissions-responses-tabs": {
          title: "Responses & Submissions Tabs",
          description: "When responses or submissions are enabled for a project, you'll see tabs here to review and moderate them. Let's check out the demo responses and submissions that have been created for this tutorial."
        },
        "organisational-welcome": {
          title: "Organisational Projects Tutorial",
          description: "Welcome to the Organisational Projects tutorial! Learn how to manage closed organisational projects that are private to your organisation. These projects are only visible to members of your organisation, and new members automatically get access when they join."
        },
        "organisational-members-view": {
          title: "View Organisation Members",
          description: "Here you can see all members of your organisation, including students and moderators. Members are automatically given access to all closed organisational projects when they join."
        },
        "organisational-projects-overview": {
          title: "Closed Organisational Projects",
          description: "Closed organisational projects are private projects that only members of your organisation can see and access. These projects are perfect for educational settings, workshops, or internal initiatives."
        },
        "organisational-create-project": {
          title: "Create a New Closed Project",
          description: "Click this button to create a new closed organisational project. The project will be private to your organisation, and all current and future members will automatically have access to it."
        },
      },
      floatingMenu: {
        title: "Additional Tutorials",
        twinningButton: "Twinning Pins",
        qrButton: "QR Code Pins",
        submissionsResponsesButton: "Submissions & Responses",
        organisationalProjectsButton: "Organisational Projects",
        exitOrganisationalDemo: "Exit Organisation Demo"
      },
      switchBackToRegularDemo: "Switch Back to Regular Demo",
      modes: {
        sequential: {
          title: "Sequential Mode",
          description: "In Sequential mode, pins must be collected in a specific order. Each pin is numbered, and listeners must collect them sequentially (1, 2, 3, etc.). This creates a guided experience where listeners follow a predetermined path through your content."
        },
        branching: {
          title: "Branching Mode",
          description: "In Branching mode, pins can branch from parent pins, creating a tree-like structure. Listeners can explore different paths and branches, allowing for multiple storylines or routes through your content."
        },
        episode: {
          title: "Episode Mode",
          description: "Episode mode lets listeners collect the next episode in a story from any pin in the project."
        },
        regular: {
          title: "Regular Mode",
          description: "In Regular mode, pins can be collected in any order. Listeners have complete freedom to explore your content at their own pace and in whatever sequence they choose."
        }
      },
      formsview: {
        title: "Forms View - Public Submission Form",
        description: "Forms View allows you to create a public submission form that external contributors can use to submit recordings. You can share a link to the form, optionally protect it with a password, and configure which fields contributors need to fill in. Submitted recordings will appear in your pin list view where you can review and assign them to pins."
      }
    },
    mobile: {
      limitedFeatures: "Limited features on mobile",
      useLargeScreen: "To access all features including Map View, please use a large screen device.",
      longPressToMovePin: "Long-press a pin to unlock it, then drag to move. Tap a pin to edit."
    }
}